import React from "react";
import { Container, Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { IApplicationState } from "@/store-redux";
import { isPremiumUser } from "@/helpers";
import { ERole } from "@/common";
import { KeyTokenName } from "@/constants";
import PremiumContent from "@/components/Premium/PremiumContent";

interface PremiumGuardProps {
  children: React.ReactNode;
}

const PremiumGuard: React.FC<PremiumGuardProps> = ({ children }) => {
  const currentUser = useSelector((state: IApplicationState) => state.currentUser);
  const token = localStorage.getItem(KeyTokenName);

  // If currentUser profile is not yet loaded and either a fetch is in progress
  // or a token exists, show loading spinner. Do not unmount children during background re-fetching.
  const isLoading = !currentUser.data && (currentUser.isFetching || (!!token && !currentUser.error));

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          width: "100%",
        }}
      >
        <CircularProgress sx={{ color: "#0D9488" }} size={40} thickness={4} />
      </Box>
    );
  }

  const isPremium = isPremiumUser(currentUser?.data);
  const isAdmin =
    currentUser?.data?.role === ERole.SUPER_ADMIN ||
    currentUser?.data?.role === ERole.ADMIN ||
    currentUser?.data?.role === ERole.TEACHER;

  // Admins and Teachers bypass premium checks for management
  if (isPremium || isAdmin) {
    return <>{children}</>;
  }

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <PremiumContent />
    </Container>
  );
};

export default PremiumGuard;
